import { AllHtmlEntities } from 'html-entities'

export default body => {
  let dBody = AllHtmlEntities.decode(body)
  dBody = dBody.replace(/<\/?pre>/gm, '')
  return dBody
}
